/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CartQuantitySelect_item$ref = any;
export type CartQuantitySelect_item = {
    readonly quantity: number | null;
    readonly hasUnlimitedQuantity: boolean | null;
    readonly setSize: number | null;
    readonly quantitySelectOptions: ReadonlyArray<{
        readonly label: string | null;
        readonly value: number | null;
    } | null> | null;
    readonly " $refType": CartQuantitySelect_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartQuantitySelect_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantity",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasUnlimitedQuantity",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "setSize",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "quantitySelectOptions",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemQuantityOption",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "label",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "value",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '475302b2cb0f6cbeb7aaf772928cc3ac';
export default node;
